import PaymentsResource from './payments';

export default function BlockchainResource({ base }) {
  const blockchainBase = `${base}/blockchain/v1`;

  return {
    Payments: PaymentsResource({ base: blockchainBase }),
  };
}
